import { defineStore } from "pinia";
import { isMiembroCurso } from "@/utils/courseRoles";
export const useCursoStore = defineStore("curso", {
    state: () => ({
        selectedCursoData: JSON.parse(localStorage.getItem("selectedCursoData") || "null"),
    }),
    actions: {
        // Método específico para establecer un curso válido
        setCurso(cursoData) {
            this.selectedCursoData = cursoData;
            localStorage.setItem("selectedCursoData", JSON.stringify(cursoData));
        },
        // Método específico para limpiar el curso (más explícito)
        setCursoNull() {
            this.selectedCursoData = null;
            localStorage.removeItem("selectedCursoData");
        },
        getCursoData() {
            // Si no hay datos del curso en el store, intentamos recuperarlos del localStorage
            if (!this.selectedCursoData) {
                const storedCursoData = localStorage.getItem("selectedCursoData");
                if (storedCursoData) {
                    this.selectedCursoData = JSON.parse(storedCursoData);
                }
            }
            return this.selectedCursoData;
        },
        clearCurso() {
            this.selectedCursoData = null;
            localStorage.removeItem("selectedCursoData");
        },
        // Curso con identificadores mínimos (school_id, year, course_code|course_id)
        hasCurso() {
            return isMiembroCurso(this.getCursoData());
        },
    },
});
